import React from 'react';

import { StyledDots, StyledDotsContainer } from './styles';

const Init: React.FC = (props) => {
  return (
    <StyledDotsContainer data-testid="dots" {...props}>
      <StyledDots />
      <StyledDots />
      <StyledDots />
    </StyledDotsContainer>
  );
};

export default Init;
